import script from "./UtmBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./UtmBuilder.vue?vue&type=script&setup=true&lang=js"

import "./UtmBuilder.vue?vue&type=style&index=0&id=2c18caea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c18caea"]])

export default __exports__